module.exports = __webpack_public_path__ + "static/media/A18040103_10002_1.e772a7f7.jpg";